import constantFactory from "@gaoding/constant-factory";

export const { SORT, SORT_LIST, SORT_MAP, SORT_ITEM_MAP } = constantFactory(
  "SORT",
  [
    {
      key: "ALL",
      label: "综合排序",
      value: "0",
      // icon: 'ic_sort'
    },
    {
      key: "TIME",
      label: "时间排序",
      value: "1",
      // icon: 'recent_fill'
    },
  ]
);
